module.exports = __webpack_public_path__ + "img/2.c963a42a.jpg";